import { t } from '@lingui/core/macro';

import MoreIcon from '@/assets/svg/bx-dots-vertical-rounded.svg?react';
import { Button } from '@/components/buttons';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/DropdownMenu';
import { csvDownloadRowLimit } from '@/constants';
import { ExportCSVAction } from '@/features/ExportCSVAction';

type Props = {
  totalResults?: number;
  isLoading?: boolean;
  isDownloadingCSV?: boolean;
  onDownloadCSV?: () => void;
};

const AudienceMembershipActionMenu = ({
  totalResults,
  isLoading,
  isDownloadingCSV,
  onDownloadCSV,
}: Props) => {
  const downloadRowLimitReached = totalResults != null && totalResults > csvDownloadRowLimit;
  const exportDisabled = downloadRowLimitReached || isLoading || isDownloadingCSV;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button aria-label={t`More actions`} variant="ghost" size="icon">
            <MoreIcon />
          </Button>
        }
      />
      <DropdownMenuContent align="end">
        <DropdownMenuItem disabled={exportDisabled} onClick={onDownloadCSV}>
          <ExportCSVAction downloadRowLimitReached={downloadRowLimitReached} />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AudienceMembershipActionMenu;
